var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { staticClass: "gp-modal", style: _vm.windowCls }, [
    _c(
      "div",
      { staticClass: "tree-panel" },
      [
        _c(
          "button",
          {
            staticClass: "close-modal",
            attrs: { type: "button" },
            on: { click: _vm.sendCloseTree }
          },
          [_c("v-icon", { attrs: { light: "" } }, [_vm._v("mdi-close-box")])],
          1
        ),
        _c(
          "div",
          { staticClass: "user-search" },
          [
            _c("v-text-field", {
              attrs: {
                placeholder: "Pesquisar",
                outlined: "",
                rounded: "",
                dense: "",
                "prepend-inner-icon": "mdi-magnify"
              },
              model: {
                value: _vm.searchUser,
                callback: function($$v) {
                  _vm.searchUser = $$v
                },
                expression: "searchUser"
              }
            })
          ],
          1
        ),
        _c("v-treeview", {
          ref: "user_tree",
          attrs: {
            items: _vm.tree,
            activatable: "",
            hoverable: "",
            dense: "",
            search: _vm.searchUser,
            filter: _vm.filterUser
          },
          scopedSlots: _vm._u([
            {
              key: "prepend",
              fn: function(ref) {
                return [_c("v-icon", [_vm._v("mdi-account")])]
              }
            },
            {
              key: "label",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "v-row",
                    {
                      style: _vm.getItemCls(item),
                      on: {
                        click: function($event) {
                          return _vm.changeUser(item)
                        }
                      }
                    },
                    [
                      _c("v-col", [_vm._v(_vm._s(item.name))]),
                      _c("v-col", [_vm._v(_vm._s(item.email))]),
                      _c("v-col", [
                        _vm._v(_vm._s(_vm.idFormatter.format(item.document)))
                      ])
                    ],
                    1
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }